import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Paper, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Typography, IconButton } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from "./styles";
import DeleteIcon from '@mui/icons-material/Delete';

interface LatLongModalProps {
    modalOpen: boolean;
    coordinates: any;
    setModalOpen: (value: boolean) => void;
    handleInputChange: Function;
    selectedOption: any;
    handleOptionChange: Function;
    handleClearCoordinates: Function;
}

const LatLongModalComponent: React.FC<LatLongModalProps> = (props) => {
    const style = useStyles();
    return (
        <Dialog
            open={props.modalOpen}
            PaperProps={{ style: { width: '40%' } }}
            onClose={() => props.setModalOpen(false)}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                <Typography>Vehicle Location</Typography>
                <IconButton
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={() => props?.setModalOpen(false)}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Paper className={style.paper}>
                    <div className="headerAndInputs">
                        <div className="inputWrap">
                            <div className="latitudeColumn">
                                <h3 className="headText">Latitude</h3>
                                {Array.from(Array(4).keys()).map((index) => (
                                    <div key={index} className="latitudeInput">
                                        <TextField
                                            type="number"
                                            name={`lat${index}`}
                                            value={
                                                props?.coordinates[index][0] === null
                                                    ? ""
                                                    : props?.coordinates[index][0]
                                            }
                                            onChange={(e) => props?.handleInputChange(e, index * 2)}
                                            fullWidth
                                            margin="normal"
                                            placeholder="Latitude"
                                        />
                                        <span className="indexes">{index + 1}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="longitudeColumn">
                                <h3 className="headText">Longitude</h3>
                                {Array.from(Array(4).keys()).map((index) => (
                                    <div key={index} className="longitudeInput">
                                        <TextField
                                            type="number"
                                            name={`lng${index}`}
                                            value={
                                                props?.coordinates[index][1] === null
                                                    ? ""
                                                    : props?.coordinates[index][1]
                                            }
                                            onChange={(e) => props?.handleInputChange(e, index * 2 + 1)}
                                            fullWidth
                                            margin="normal"
                                            placeholder="Longitude"
                                        />
                                        <span className="indexes">{index + 1}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="radioBtnWrap">
                            <div className="resetBtnWrap" >
                                <Button className="resetBtn" startIcon={<DeleteIcon />} variant="contained" size="small" onClick={(e) => props?.handleClearCoordinates(e)}>Clear All</Button>
                            </div>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={props?.selectedOption}
                                    onChange={(e) => props?.handleOptionChange(e)}
                                >
                                    <FormControlLabel
                                        value="in_bond"
                                        control={<Radio />}
                                        label="Within Range"
                                    />
                                    <FormControlLabel
                                        value="out_bond"
                                        control={<Radio />}
                                        label="Outside Range"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>
                </Paper>
            </DialogContent>
        </Dialog>
    );
};

export default LatLongModalComponent;
